import type { FC, SVGProps } from 'react'

export const ReownLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 200 200"
    {...props}
  >
    <title>Reown</title>
    <g transform="translate(0,200) scale(0.1,-0.1)" fill="#000" stroke="none">
      <path d="M0 1000 l0 -1000 1000 0 1000 0 0 1000 0 1000 -1000 0 -1000 0 0 -1000z m654 388 c53 -16 118 -81 134 -134 17 -56 17 -452 0 -508 -7 -23 -30 -59 -53 -81 -106 -106 -276 -78 -346 57 -17 34 -19 61 -19 278 0 217 2 244 19 278 52 101 154 143 265 110z m817 0 c52 -15 117 -73 140 -122 16 -36 19 -69 19 -266 0 -257 -5 -279 -79 -342 -63 -54 -98 -60 -341 -56 -239 3 -247 5 -315 75 -55 57 -65 107 -65 323 0 198 9 255 48 305 30 38 69 66 111 81 47 17 427 19 482 2z" />
      <path d="M560 920 c0 -15 7 -20 25 -20 18 0 25 5 25 20 0 15 -7 20 -25 20 -18 0 -25 -5 -25 -20z" />
      <path d="M1206 1017 c-31 -85 -56 -157 -56 -160 0 -4 8 -7 18 -7 16 0 40 57 130 311 2 5 -5 9 -16 9 -16 0 -29 -28 -76 -153z" />
    </g>
  </svg>
)
